import React, { FC } from 'react';

export const MaybeUnselectedIcon: FC<React.PropsWithChildren<{ color?: string }>> = ({
  color = 'black'
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3H17C18.1 3 19 3.9 19 5V21L12 18L5 21V5C5 3.9 5.9 3 7 3ZM12 15.82L17 18V5H7V18L12 15.82Z"
        fill={color}
      />
    </svg>
  );
};
